import { render, staticRenderFns } from "./BetsTable.vue?vue&type=template&id=01afceab&scoped=true&"
import script from "./BetsTable.vue?vue&type=script&lang=js&"
export * from "./BetsTable.vue?vue&type=script&lang=js&"
import style0 from "./BetsTable.vue?vue&type=style&index=0&id=01afceab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01afceab",
  null
  
)

export default component.exports